import React from 'react';
import { Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { CONFIG } from '../data/villaData';
import MoonlitLogo from './MoonlitLogo';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1a1a1a] text-stone-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          <div>
            <MoonlitLogo mode="dark" className="h-24 w-auto mb-4" />
            <p className="text-sm text-stone-400 italic">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="text-white font-serif text-xl mb-4">{t.contact.title}</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Phone size={15} className="text-[#b8945e]" />
                <a href={`tel:+${CONFIG.whatsapp}`} className="hover:text-[#b8945e] transition-colors">{CONFIG.whatsappDisplay}</a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={15} className="text-[#b8945e]" />
                <span>{CONFIG.address}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-serif text-xl mb-4">{t.nav.book}</h4>
            <a href={CONFIG.bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-block px-5 py-2.5 bg-[#003580] hover:bg-[#002650] text-white text-sm rounded-full transition-colors mb-3">
              Booking.com
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-center text-xs text-stone-500">
          © {new Date().getFullYear()} Moonlit Villa. {t.footer.rights}
        </div>
      </div>
    </footer>
  );
}
